import { ALL_TRADES_LIST, ALL_TRADES_LIST_SUCCESS, ALL_TRADES_LIST_FAILURE } from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  allTradesData: null,
};

const allTradesReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ALL_TRADES_LIST:
      return { ...state, loading: true };
    case ALL_TRADES_LIST_SUCCESS:
      return {
        ...state,
        allTradesData: action?.payload,
        loading: false,
      };
    case ALL_TRADES_LIST_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default allTradesReducer;